import submitToJournalLoad from "~/store/graphql/queries/submitToJournalLoad.graphql";
import runGraphQLQuery, {
  lastQuery,
} from "~/store/manage/utilities/runGraphQLQuery";

const loadJournalDetails = async function (
  { commit },
  { params, req, res, saveLastGraphQL }
) {
  commit("START_LOADING");

  const data = await runGraphQLQuery(
    submitToJournalLoad,
    params,
    this.$axios,
    req,
    res
  );
  if (saveLastGraphQL === true) {
    commit("SET_LAST_GRAPHQL", lastQuery());
  }

  commit("SET_ARTICLE_DETAILS", data);
  commit("SET_JOURNAL_DETAILS", data);
  commit("END_LOADING");

  return Promise.resolve(data);
};

export default loadJournalDetails;
